<template>
  <ul class="nav nav-mobile-menu">
  
   
  </ul>
</template>
<script>
  export default {}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/MobileMenu.vue